/*
 * Contact routing. A topic can be preselected two ways:
 *   - a route card on the contact page itself (click),
 *   - a `?thema=` parameter on a link from any other page.
 * Both are enhancements: the links are ordinary anchors to the form, so
 * without JavaScript the jump still works and only the preselection is lost.
 */
function nexthermSelectTopic(topic) {
  const select = document.querySelector('[data-contact-topic-select]');
  if (!select || !topic) return false;

  const wanted = topic.trim().toLowerCase();
  const match = [...select.options].find((option) => option.value.trim().toLowerCase() === wanted);
  if (!match) return false;

  select.value = match.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));
  return true;
}

if (!customElements.get('contact-routes')) {
  class ContactRoutes extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-contact-topic]');
        if (!trigger) return;
        if (!nexthermSelectTopic(trigger.dataset.contactTopic)) return;

        // Let the browser handle the anchor jump, then move focus into the form
        // so keyboard users land where the click pointed.
        requestAnimationFrame(() => {
          const field = document.querySelector('[data-contact-first-field]');
          if (field) field.focus({ preventScroll: true });
        });
      });
    }
  }

  customElements.define('contact-routes', ContactRoutes);
}

// Preselection for visitors arriving from another page.
(() => {
  const applyFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    nexthermSelectTopic(params.get('thema') || params.get('topic'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFromUrl, { once: true });
  } else {
    applyFromUrl();
  }
})();
